import { Reveal, MaskedLine } from "./Reveal";

export const SectionHeading = ({ eyebrow, lines, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "text-center" : "text-left"} ${className}`}>
    <Reveal y={20}>
      <p className="eyebrow mb-5" data-testid={`eyebrow-${eyebrow.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
        {eyebrow}
      </p>
    </Reveal>
    <h2 className="font-display font-light tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
      {lines.map((line, i) => (
        <MaskedLine key={i} delay={0.08 * i}>
          {line}
        </MaskedLine>
      ))}
    </h2>
  </div>
);
